import { render, staticRenderFns } from "./EfectosForm.vue?vue&type=template&id=47ed5429&scoped=true"
import script from "./EfectosForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EfectosForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EfectosForm.vue?vue&type=style&index=0&id=47ed5429&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ed5429",
  null
  
)

export default component.exports